import Glyph from "@/components/Glyph";
import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import PlanetSheet from "@/components/PlanetSheet";

const GLYPH = { Sun: "☉", Moon: "☽", Mercury: "☿", Venus: "♀", Mars: "♂", Jupiter: "♃", Saturn: "♄" };

export default function SkyStrip({ onSubscribe, onLockedTap }) {
  const [sky, setSky] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/sky/today").then(({ data }) => setSky(data)).catch(() => {});
  }, []);
  if (!sky) return null;
  return (
    <div data-testid="sky-strip" className="mb-5 bg-[#0B0F19]/70 border border-[#D4AF37]/20 rounded-2xl px-4 py-3">
      <div className="flex items-center justify-between mb-2">
        <p className="text-[11px] uppercase tracking-[0.25em] gold-text">Today's Sky</p>
        <p data-testid="sky-moon-phase" className="text-xs text-[#A7B0C0]">
          {sky.moon_phase} · {sky.moon_illumination}%
        </p>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
        {sky.planets.map((p) => (
          <button
            key={p.planet}
            data-testid={`sky-planet-${p.planet.toLowerCase()}`}
            onClick={() => (onLockedTap ? onLockedTap() : setOpen(p.planet))}
            className="shrink-0 flex flex-col items-center min-w-[64px] bg-[#0F1523] border border-[#D4AF37]/15 hover:border-[#D4AF37]/50 rounded-xl px-2 py-1.5 transition-colors"
          >
            <Glyph ch={GLYPH[p.planet]} className="gold-text text-lg leading-none" />
            <span className="text-[11px] text-[#E8DCC4] mt-1">{p.sign}</span>
            <span className="text-[10px] text-[#6c7686]">
              {p.degree}°{p.retrograde && <span className="text-[#e08a7a]"> Rx</span>}
            </span>
          </button>
        ))}
      </div>
      <p className="text-[10px] text-[#6c7686] mt-1">Tap a planet to see what it means</p>
      {!onLockedTap && <PlanetSheet planet={open} glyph={GLYPH[open]} onClose={() => setOpen(null)} onSubscribe={onSubscribe} />}
    </div>
  );
}
